import React, { useContext } from "react";
import { Box } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";
import SubMenu from "../components/SubMenu";
import AddExhibit from "../components/AddExhibit";
import ManageExhibit from "../components/ManageExhibit";
import { databaseMenuOptions } from "../data/database";
import { hasAccess } from "../functions";
import { prodApi } from "../data/api";

const dataUrl = prodApi.data;
const exhibitUrl = `${dataUrl}/exhibits`;

const DatabaseExhibit = ({ maxWidth }) => {
  const { loggedIn, isLoggedIn } = useContext(AuthContext);
  return (
    <>
      {loggedIn &&
        hasAccess(isLoggedIn.accessLevel, ["data", "omni", "admin"]) && (
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                minHeight: "110dvh",
                width: "90%",
                maxWidth: maxWidth,
                zIndex: 0,
                m: "auto",
                p: "auto",
              }}
            >
              <Box
                sx={{
                  mt: 9,
                  fontSize: "2rem",
                  fontWeight: "200",
                }}
              >
                Data Management
              </Box>
              <Box
                sx={{
                  mb: 1.5,
                  fontSize: "1.25rem",
                  fontWeight: "200",
                }}
              >
                Exhibit
              </Box>
              <SubMenu menuOptions={databaseMenuOptions} />

              <Box sx={{ mt: "2rem" }}>
                <ManageExhibit
                  header="Manage Exhibits"
                  userId={isLoggedIn.uniqueId}
                  dataUrl={exhibitUrl}
                />
              </Box>

              <Box sx={{ mt: "2rem" }}>
                <AddExhibit
                  userId={isLoggedIn.uniqueId}
                  exhibitUrl={exhibitUrl}
                  header="Add New Exhibit"
                />
              </Box>

              <Box sx={{ height: "10dvh" }} />
            </Box>
          </Box>
        )}
    </>
  );
};

export default DatabaseExhibit;
